// Scripts for the division news page template
'use strict'

/**
 * Imports SCSS for Webpack parsing and sets strict mode
 */
import '../../../styles/src/pages/division-news.scss';

/*
 * Component imports
 */
// Blog featured categories navigation
import '../components/blog/blog-navigation';
// Blog pagination
import '../components/blog/pagination';
// Recent posts
import '../components/sidebar/recent-posts';
// Centered content, when present
import '../components/general/centered-content';
// Link block
import '../components/sidebar/link-block';
// Division feature
import '../components/division/feature';
// CTA promotion
import '../components/promotions/calls-to-action';
// Testimonial promotion
import '../components/promotions/testimonial';

/*
 * Page-specific scripting
 */
